export const WOO_STORE_API_PATH = "/wp-json/wc/store";
export const WOO_STORE_API_PATH_PROXY = "/api/store";

export const LOCAL_VERCEL_SERVER_DOMAIN = "http://localhost:3000";
